import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

const AdminNavLink = ({ theme, collapsed, onClick }) => {
  const { getToken, isSignedIn, isLoaded } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      // Wait for Clerk to be fully loaded
      if (!isLoaded) {
        return;
      }

      if (!isSignedIn) {
        setLoading(false);
        return;
      }

      try {
        const token = await getToken();
        const response = await fetch('https://parrotmate.com/api/auth/me', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const userData = await response.json();
          setIsAdmin(userData.is_admin || false);
        }
      } catch (error) {
        console.error('Failed to check admin status:', error);
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [isLoaded, isSignedIn, getToken]);

  if (!isLoaded || loading || !isAdmin) {
    return null;
  }

  return (
    <Link 
      to="/admin" 
      onClick={onClick}
      className={`
        w-full flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-colors
        ${theme === 'dark' 
          ? 'text-red-400 hover:text-red-300 border border-red-400 hover:border-red-300' 
          : 'text-red-600 hover:text-red-700 border border-red-600 hover:border-red-700'
        }
      `}
      title={collapsed ? 'Admin Panel' : ''}
    >
      <span className="text-lg flex-shrink-0">⚙️</span>
      {!collapsed && (
        <span className="ml-3">Admin</span>
      )}
    </Link>
  );
};

export default AdminNavLink;
